import { Link } from "react-router-dom";

const categories = [
  {
    label: "i-clothes",
    sublabel: "Satin Dresses & Tops",
    href: "/collections/clothes",
    image: "https://readdy.ai/api/search-image?query=high%20fashion%20model%20wearing%20glossy%20satin%20coordinated%20outfit%20with%20pearl%20shimmer%2C%20dark%20studio%20background%20with%20dramatic%20side%20lighting%2C%20luxury%20clothing%20campaign%20editorial%20photography%2C%20flowing%20fabric%20with%20luminous%20quality%2C%20elegant%20feminine%20aesthetic%2C%20silver%20and%20ivory%20tones&width=600&height=800&seq=iif_cat_clothes_001&orientation=portrait",
    description: "Dresses, blouses & skirts in lustrous fabrics.",
  },
  {
    label: "i-shoes",
    sublabel: "Patent & Metallic Heels",
    href: "/collections/shoes",
    image: "https://readdy.ai/api/search-image?query=collection%20of%20luxury%20patent%20leather%20and%20pearlescent%20high%20heels%20arranged%20artistically%20on%20dark%20polished%20marble%20surface%2C%20soft%20moonlight%20illumination%2C%20elegant%20feminine%20shoe%20photography%2C%20high%20fashion%20editorial%2C%20silver%20and%20pearl%20color%20palette&width=600&height=800&seq=iif_cat_shoes_001&orientation=portrait",
    description: "Heels, mules & sandals with luminous finishes.",
  },
  {
    label: "i-bag",
    sublabel: "Satin & Holographic Bags",
    href: "/collections/bags",
    image: "https://readdy.ai/api/search-image?query=luxury%20collection%20of%20satin%20evening%20clutch%20bags%20and%20iridescent%20holographic%20shoulder%20bags%20arranged%20elegantly%20on%20dark%20velvet%20surface%20with%20moonlight%20reflection%2C%20high%20fashion%20handbag%20editorial%20photography%2C%20silver%20gold%20tones%2C%20minimalist%20luxury&width=600&height=800&seq=iif_cat_bags_001&orientation=portrait",
    description: "Clutches, shoulder bags & accessories.",
  },
  {
    label: "i-nails",
    sublabel: "Cat Eye & Aurora Press-Ons",
    href: "/collections/nails",
    image: "https://readdy.ai/api/search-image?query=elegant%20female%20hands%20with%20beautiful%20cat%20eye%20magnetic%20gel%20press%20on%20nails%20in%20pearlescent%20moonlight%20white%20and%20silver%20aurora%20iridescent%20finish%2C%20holding%20a%20crystal%20champagne%20glass%2C%20dark%20luxurious%20background%20with%20candlelight%20bokeh%2C%20high%20fashion%20nail%20beauty%20photography%2C%20close%20up%20glamour%20shot%2C%20mesmerizing%20shimmer%20and%20light%20reflection&width=600&height=800&seq=iif_cat_nails_001&orientation=portrait",
    description: "Cat eye, aurora & pearl press-on nails.",
  },
];

export default function CategorySection() {
  return (
    <section
      className="py-20 lg:py-28 px-6 lg:px-16 bg-moonlight"
      style={{ fontFamily: "'Jost', sans-serif" }}
    >
      {/* Section Header */}
      <div className="text-center mb-14">
        <p
          className="text-[10px] tracking-ultra-wide uppercase text-midnight/40 mb-3"
          style={{ letterSpacing: "0.3em" }}
        >
          Shop by Category
        </p>
        <h2
          className="text-3xl md:text-4xl font-light italic text-midnight"
          style={{ fontFamily: "'Cormorant Garamond', serif" }}
        >
          Find Your Glow
        </h2>
      </div>

      {/* Category Grid — 2 cols on mobile, 4 cols on desktop */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6 max-w-6xl mx-auto">
        {categories.map((cat) => (
          <a
            key={cat.href}
            href={cat.href}
            className="group block cursor-pointer"
          >
            {/* Image */}
            <div
              className="relative w-full overflow-hidden bg-pearl/20"
              style={{ aspectRatio: "3/4" }}
            >
              <img
                src={cat.image}
                alt={cat.label}
                className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-midnight/65 via-transparent to-transparent" />

              {/* Bottom Label */}
              <div className="absolute bottom-0 left-0 right-0 px-4 py-5 lg:px-6 lg:py-6">
                <p
                  className="text-xl lg:text-2xl font-light italic text-moonlight mb-0.5"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {cat.label}
                </p>
                <p className="text-[9px] tracking-widest uppercase text-moonlight/70 mb-2 hidden sm:block">
                  {cat.sublabel}
                </p>
                <span className="inline-flex items-center gap-1.5 text-[9px] tracking-widest uppercase text-moonlight/80 group-hover:text-moonlight transition-colors">
                  Shop Now
                  <i className="ri-arrow-right-line text-xs transition-transform group-hover:translate-x-1" />
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}
